import React from "react";
import styled from "styled-components";

const TooltipContainer = styled.div`
	box-sizing: border-box;
	width: 16px;
	height: 16px;
	background: #ffffff;
	border: 1px solid #000000;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	position: relative;

	&:hover span {
		visibility: visible;
		opacity: 1;
	}
`;

const TooltipText = styled.span`
	visibility: hidden;
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%);
	background: #333;
	color: white;
	padding: 8px 12px;
	border-radius: 4px;
	font-size: 14px;
	white-space: normal;
	min-width: 150px;
	text-align: center;
	margin-bottom: 8px;
	z-index: 100;
	opacity: 0;
	transition: opacity 0.3s;

	/* Add a tooltip arrow */
	&::after {
		content: "";
		position: absolute;
		top: 100%; /* Bottom of the tooltip */
		left: 50%;
		margin-left: -5px;
		border-width: 5px;
		border-style: solid;
		border-color: #333 transparent transparent transparent;
	}
`;

// Simple standalone component that can be used anywhere
interface QuestionMarkTooltipProps {
	message: string;
}

const QuestionMarkTooltip: React.FC<QuestionMarkTooltipProps> = ({ message }) => {
	return (
		<TooltipContainer>
			?<TooltipText>{message}</TooltipText>
		</TooltipContainer>
	);
};

export default QuestionMarkTooltip;
